import { format, parseISO, isValid } from 'date-fns';

export const ParseDateString = (date = '') => {
  if (!isValid(parseISO(date))) return null;

  return format(parseISO(date), 'dd/MM/yyyy');
};
